import(/* webpackMode: "eager" */ "/vercel/path0/src/app/lessons/page.tsx");
